import { api, AIOPS_API_BASE_URL } from "../../../api";

/**
 * Service for managing external ITSM, observability, and webhook integrations.
 */

export async function fetchIntegrations(params = {}) {
  const query = new URLSearchParams();
  if (params.category) query.append("category", params.category);
  if (params.provider) query.append("provider", params.provider);
  if (params.status) query.append("status", params.status);
  if (params.limit) query.append("limit", params.limit);
  if (params.offset) query.append("offset", params.offset);

  const qs = query.toString() ? `?${query.toString()}` : "";
  return api(`/integrations/${qs}`);
}

export async function createIntegration(payload) {
  return api("/integrations/", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function updateIntegration(id, payload) {
  return api(`/integrations/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export async function deleteIntegration(id) {
  return api(`/integrations/${id}`, {
    method: "DELETE",
  });
}

export async function validateConnection({ integrationId, provider, config }) {
  const body = {};
  if (integrationId) body.integration_id = integrationId;
  if (provider) body.provider = provider;
  if (config) body.config = config;

  return api("/integrations/validate-connection", {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export async function fetchWebhookProviders() {
  return api("/webhooks/providers");
}

export function buildFullWebhookUrl(path, token = null) {
  if (!path) return "";
  const tokenQuery = token ? `?token=${encodeURIComponent(token)}` : "";
  if (path.startsWith("http://") || path.startsWith("https://")) {
    const hasQuery = path.includes("?");
    const cleanUrl = path.replace(/\/+$/, "");
    return token ? `${cleanUrl}${hasQuery ? "&" : "?"}token=${encodeURIComponent(token)}` : cleanUrl;
  }
  const base = AIOPS_API_BASE_URL || window.location.origin;
  const cleanBase = base.replace(/\/+$/, "");
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  return `${cleanBase}${cleanPath}${tokenQuery}`;
}
